import Utils from 'common/utils';
import type { ICaptchaReportParams } from 'common/utils/captchaRequest';
import { APP_REPORT_KEY } from 'common/utils/dataReport';
import JSRuntime from 'common/utils/JSRuntime';
import { ENTERPRISE_LOGIN_TYPE, LOGIN_VERIFY_TYPE } from '../Constants';

/**
 * 创建滑块验证码上报参数，传入 captchaRequest / newCaptchaRequest 进行上报
 * @param globalParams 公参（由 rootStore.getReportGlobalParams() 提供）
 * @param verifyType 验证类型：1-新用户注册, 2-手机号验证码登录, 7-邮箱验证码登录, 8-重置密码, 10-管理员邀请人员, 13-免费注册, 15-SSO账号密码, 0-其他
 * @returns 滑块上报参数对象，直接作为 captchaRequest 的第三个参数
 */
export const createCaptchaReport = (
  globalParams: Record<string, any>,
  verifyType: LOGIN_VERIFY_TYPE,
): ICaptchaReportParams => ({
  globalParams,
  privateParams: { verify_type: verifyType },
  reportOptions: {
    [APP_REPORT_KEY.WEMEET]: JSRuntime.isTencentMeeting,
  },
});

/** 获取 URL 中 acr_values 参数值（# 前的查询参数） */
export const getAcrValues = (): string | undefined => {
  const searchParams = JSRuntime.parseLocationSearch();
  return _.get(searchParams, 'acr_values') || undefined;
};

export const loginOtherAccount = () => {
  const search = _.get(window.location, 'search');
  const searchParams = JSRuntime.parseLocationSearch(search);
  const loginType = _.get(searchParams, 'amr');
  // TIPS: 如果是sso发起登录，选择其他账号回到sso登录页面；如果是自然人发起登录，选择其他账号回到自然人登录页
  if (loginType === ENTERPRISE_LOGIN_TYPE) {
    Utils.redirectToIdp(search, '/sso_login/identity');
    return;
  }
  Utils.redirectToOriginalIdp(search, '/login');
};
